/**
 * Tile URL utilities for XYZ/TMS tile services
 */
import { IS_LOCAL_API, LOCAL_TILE_ENDPOINT } from '@droidmap/frontend-env'
import type { CogType } from '@droidmap/token-service-contract'

/**
 * Detect COG type from asset name
 */
export const detectCogType = (name: string): CogType | null => {
  const lower = name.toLowerCase()
  if (lower.includes('dsm')) return 'dsm'
  if (lower.includes('dtm')) return 'dtm'
  if (lower.includes('orthophoto')) return 'orthophoto'
  return null
}

/**
 * Build an XYZ tile URL for an asset.
 *
 * When a `token` (an XYZ tile token string) is supplied it is embedded as a
 * `?token=` query param — the portable credential form for GIS tools (QGIS
 * XYZ layers, ArcGIS) that can't attach an `Authorization` header. The tile
 * service accepts the token from either the query param or a Bearer header.
 */
export const buildTileUrl = (
  assetId: string,
  env: string,
  cogType?: CogType,
  token?: string,
): string => {
  const params = new URLSearchParams()
  if (cogType) params.set('cog_type', cogType)
  if (token) params.set('token', token)
  const query = params.toString() ? `?${params.toString()}` : ''

  // Local dev: COG tiles come from the locally-run tile-service.
  if (IS_LOCAL_API) {
    return `${LOCAL_TILE_ENDPOINT}/tiles/${assetId}/{z}/{x}/{y}.png${query}`
  }
  const envPrefix = env === 'prod' ? '' : `${env}.`
  return `https://tile.api.${envPrefix}droidmap.com/tiles/${assetId}/{z}/{x}/{y}.png${query}`
}
